export const BUSINESS = {
  name: "WARNRS INDUSTRIES",
  legal: "WARNRS INDUSTRIES PTY LTD",
  tagline: "Auto Electrician & Light Vehicle Mechanic",
  phone: "0417 609 270",
  phoneHref: "tel:+61417609270",
  email: "warnrsindustries@gmail.com",
  area: "Mackay & Surrounding Areas",
  region: "Queensland, Australia",
};

export const SERVICES = [
  {
    id: "01",
    title: "Vehicle Repairs",
    slug: "Vehicle Repairs",
    blurb:
      "Servicing, diagnostics and mechanical repairs for cars, utes and light commercial vehicles.",
  },
  {
    id: "02",
    title: "Road Worthy Certificates",
    slug: "Vehicle Road Worthy Certificate",
    blurb:
      "Safety certificate inspections for registering, selling or transferring your vehicle.",
  },
  {
    id: "03",
    title: "Electrical Fit-Outs",
    slug: "Electrical Fit-Outs",
    blurb: "Auto-electrical wiring, lighting, accessories and custom vehicle fit-outs.",
  },
  {
    id: "04",
    title: "Mine Site Compliance Fit-Outs",
    slug: "Mine Site Vehicle Compliance Fit-Outs",
    blurb: "Complete mine-site compliance fit-outs.",
  },
  {
    id: "05",
    title: "Aircon Diagnostics",
    slug: "Aircon Diagnostics",
    blurb: "Air-conditioning diagnostics, re-gas and repairs to keep your cab cool.",
  },
];

// Only the customer's approved brand photo is used across the site.
export const ABOUT_IMAGE = "/warnrs-brand-bw.jpg?v=11";
export const HERO_IMAGE = "/warnrs-brand-bw.jpg?v=11";

export const GALLERY = [
  { src: "/warnrs-brand.jpg", caption: "The WARNRS Industries workshop — Mackay QLD" },
];
